<template>
  <div
    class="activity-card"
    :class="[
      type,
      active ? 'active-card' : 'idle-card',
      active ? `card-active-${activeColorName}` : '',
      isLoading ? 'is-loading' : ''
    ]"
    @click="handleClick"
  >
    <Idle v-if="!active" :datetime="datetime" :title="title" :type="type" :compact="compact" :is-loading="isLoading" />
    <Finished v-else-if="type === 'finish'" :title="title" :type="type" :datetime="datetime" :is-loading="isLoading" />
    <Active
      v-else
      :title="title"
      :type="type"
      :show-add-button="showAddButton"
      :custom-label="customActiveLabel"
      :timer="timer"
      :is-loading="isLoading"
      :date="datetime"
    />
  </div>
</template>

<script>
import Active from "./Active.vue";
import Idle from "./Idle.vue";
import Finished from "./Finished.vue";

export default {
  name: "ActivityCard",
  components: {
    Active,
    Idle,
    Finished,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
    datetime: {
      type: String,
      default: null,
    },
    timer: {
      type: Object,
      default: () => ({
        hour: null,
        minute: null,
        second: null,
      }),
    },
    customActiveLabel: {
      type: String,
      default: null,
    },
    showAddButton: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    activeColorName() {
      switch (this.type) {
        case "setup":
          return "slate";
        case "start":
          return "orange";
        case "stop":
          return "red";
        case "finish":
          return "green";
        default:
          return "orange";
      }
    },
  },
  methods: {
    handleClick() {
      if (this.isLoading) return;
      this.$emit("handleClick", this.active);
    },
  },
};
</script>

<style lang="scss">
.activity-card {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 150px;
  height: 100%;
  background: #ffffff;
  border: 1px solid #cfc4be;
  border-radius: 10px;
  box-sizing: border-box;
  transition: all 0.2s ease;
  user-select: none;
  position: relative;
  overflow: hidden;

  &:hover {
    border-color: #974900;
    box-shadow: none;
  }

  &.is-loading {
    cursor: wait;
    opacity: 0.92;
  }

  &.active-card {
    border-color: transparent;
    box-shadow: none;

    &.card-active-slate {
      background: #607d8b !important;
      border-color: #455a64 !important;
    }
    &.card-active-orange {
      background: #e68a00 !important;
      border-color: #d47e00 !important;
    }
    &.card-active-red {
      background: #ea5455 !important;
      border-color: #d64546 !important;
    }
    &.card-active-green {
      background: #28c76f !important;
      border-color: #20a359 !important;
    }
  }

  * {
    user-select: none;
  }
}

@media (max-width: 480px) {
  .activity-card {
    min-height: 160px;
  }
}

@media (min-width: 481px) and (max-width: 1024px) {
  .activity-card {
    min-height: 180px;
    border-radius: 10px;
  }
}
</style>
